import React from 'react';

const SparkleIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' {...props}>
    <path
      d='M23.6361 12.7273L24.9997 9.72727L27.9997 8.36364L24.9997 7L23.6361 4L22.2725 7L19.2725 8.36364L22.2725 9.72727L23.6361 12.7273Z'
      fill='currentColor'
    />
    <path
      d='M23.6361 19.2729L22.2725 22.2729L19.2725 23.6366L22.2725 25.0002L23.6361 28.0002L24.9997 25.0002L27.9997 23.6366L24.9997 22.2729L23.6361 19.2729Z'
      fill='currentColor'
    />
    <path
      d='M15.4545 13.272L12.7273 7.27197L10 13.272L4 15.9992L10 18.7265L12.7273 24.7265L15.4545 18.7265L21.4545 15.9992L15.4545 13.272ZM13.8073 17.0792L12.7273 19.4574L11.6473 17.0792L9.26909 15.9992L11.6473 14.9192L12.7273 12.5411L13.8073 14.9192L16.1855 15.9992L13.8073 17.0792Z'
      fill='currentColor'
    />
  </svg>
);

export default SparkleIcon;
